/* Home10 · FungiOut Pro — interacciones de la página de producto.
   No toca Releasit: los botones [data-cod-shortcut] los gestiona home10-cod-position.js. */
(function () {
  'use strict';

  /* ---------- Fechas estimadas de entrega ---------- */
  function initCheckpoints() {
    document.querySelectorAll('[data-h10-checkpoints]').forEach(function (wrap) {
      var months = (wrap.getAttribute('data-months') || '').split(',').map(function (m) { return m.trim(); });
      if (months.length !== 12) months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      var fmt = function (d) { return d.getDate() + ' ' + months[d.getMonth()]; };
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      wrap.querySelectorAll('.h10p-cp').forEach(function (cp) {
        var min = parseInt(cp.getAttribute('data-min') || '0', 10);
        var max = parseInt(cp.getAttribute('data-max') || '0', 10);
        var out = cp.querySelector('[data-h10-cp-date]');
        if (!out) return;
        out.textContent = (min === 0 && max === 0) ? fmt(add(0)) : (min === max ? fmt(add(min)) : fmt(add(min)) + ' - ' + fmt(add(max)));
      });
    });
  }

  /* ---------- Precio dinámico al cambiar de variante ---------- */
  function initVariantPrice() {
    var select = document.querySelector('[data-variant-select]');
    var dataEl = document.querySelector('[data-h10-variants]');
    if (!select || !dataEl) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var tplEl = document.querySelector('[data-h10-badge-template]');
    var tpl = '-[percent]% [amount] OFF';
    try { if (tplEl) tpl = JSON.parse(tplEl.textContent) || tpl; } catch (e) {}
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === String(select.value); });
      if (!v) return;
      var cur = document.querySelector('[data-h10-price-current]');
      var cmp = document.querySelector('[data-h10-price-compare]');
      var badge = document.querySelector('[data-h10-price-badge] span');
      var sticky = document.querySelector('[data-h10-sticky-price]');
      if (cur) cur.textContent = v.price;
      if (sticky) sticky.textContent = v.price;
      if (cmp) { cmp.textContent = v.compare || ''; cmp.hidden = !v.compare; }
      if (badge) { badge.parentElement.hidden = !v.compare; if (v.compare) badge.textContent = tpl.replace('[percent]', v.pct).replace('[amount]', v.saving); }
    });
  }

  /* ---------- Galería: miniaturas, flechas, deslizar y videos ---------- */
  function initGallery() {
    var hero = document.getElementById('hero-photo');
    var thumbsWrap = document.querySelector('[data-h10-thumbs]');
    var videoBox = document.querySelector('[data-h10-hero-video]');
    if (!hero || !thumbsWrap) return;
    var thumbs = function () { return Array.prototype.slice.call(thumbsWrap.querySelectorAll('.thumb-button')); };

    function show(btn) {
      if (!btn) return;
      hero.removeAttribute('srcset'); hero.removeAttribute('sizes');
      hero.src = btn.getAttribute('data-hero');
      hero.alt = btn.getAttribute('data-hero-alt') || hero.alt;
      thumbs().forEach(function (t) { t.classList.toggle('selected', t === btn); });
      if (videoBox) {
        var tplId = btn.getAttribute('data-h10-video');
        var tpl = tplId && document.getElementById(tplId);
        if (tpl) { videoBox.innerHTML = tpl.innerHTML; videoBox.hidden = false; }
        else { videoBox.innerHTML = ''; videoBox.hidden = true; }
      }
      var left = btn.offsetLeft - (thumbsWrap.clientWidth - btn.clientWidth) / 2;
      thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
    }
    function step(dir) {
      var list = thumbs(); if (!list.length) return;
      var i = list.findIndex(function (t) { return t.classList.contains('selected'); });
      show(list[(Math.max(i, 0) + dir + list.length) % list.length]);
    }
    thumbsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.thumb-button'); if (btn) show(btn);
    });
    document.querySelectorAll('[data-h10-gallery-step]').forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-h10-gallery-step'), 10)); });
    });
    var frame = document.querySelector('[data-h10-hero]');
    if (frame) {
      var x0 = null, y0 = null;
      frame.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
        x0 = y0 = null;
      }, { passive: true });
    }
  }

  /* ---------- Carruseles (imágenes y reseñas cortas) ---------- */
  function buildDots(track, dotsEl, slides) {
    if (!dotsEl) return function () {};
    dotsEl.innerHTML = '';
    var pages = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Ir a ' + (i + 1));
      b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' }); });
      dotsEl.appendChild(b); pages.push(b);
    });
    return function () {
      var pos = track.scrollLeft, best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0) - pos);
        if (d < bestD) { bestD = d; best = i; }
      });
      var atEnd = pos + track.clientWidth >= track.scrollWidth - 4;
      if (atEnd) best = slides.length - 1;
      pages.forEach(function (p, i) { p.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    };
  }
  function initCarousels() {
    document.querySelectorAll('[data-h10-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-h10-car-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var prev = root.querySelector('[data-h10-car-prev]'), next = root.querySelector('[data-h10-car-next]');
      var update = buildDots(track, root.querySelector('[data-h10-car-dots]'), slides);
      function arrows() {
        var max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max;
        var noScroll = track.scrollWidth <= track.clientWidth + 4;
        if (prev) prev.hidden = noScroll; if (next) next.hidden = noScroll;
        var dots = root.querySelector('[data-h10-car-dots]'); if (dots) dots.hidden = noScroll;
        update();
      }
      var stepPx = function () { return slides[0] ? slides[0].getBoundingClientRect().width + 24 : track.clientWidth; };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(arrows, 60); }, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();
    });
    document.querySelectorAll('[data-h10-mini-slider]').forEach(function (root) {
      var track = root.querySelector('.h10p-reviews-track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      var update = buildDots(track, root.querySelector('[data-h10-dots]'), slides);
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- Menú móvil ---------- */
  function initDrawer() {
    document.addEventListener('click', function (e) {
      if (e.target.matches && e.target.matches('.h10h-drawer[open]')) { e.preventDefault(); e.target.removeAttribute('open'); return; }
      if (e.target.closest('[data-h10-close-drawer]')) {
        var d = e.target.closest('details'); if (d) d.removeAttribute('open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.h10h-drawer[open]').forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  /* ---------- Barra inferior: se oculta mientras un botón de pedido está a la vista ---------- */
  function initStickyVisibility() {
    var sticky = document.querySelector('.h10p-sticky');
    if (!sticky || !('IntersectionObserver' in window)) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      sticky.classList.toggle('h10p-sticky--away', visible.size > 0);
    }, { threshold: 0.4 });
    ['#home10-cod-position', '.h10-final-cta'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { io.observe(el); });
    });
  }

  function init() { initStickyVisibility(); initCheckpoints(); initVariantPrice(); initGallery(); initCarousels(); initDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initCheckpoints(); initCarousels(); });
})();
